import { render, staticRenderFns } from "./SnakeGame.component.vue?vue&type=template&id=a5e00c22&scoped=true&"
import script from "./SnakeGame.component.vue?vue&type=script&lang=js&"
export * from "./SnakeGame.component.vue?vue&type=script&lang=js&"
import style0 from "./SnakeGame.component.vue?vue&type=style&index=0&id=a5e00c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e00c22",
  null
  
)

export default component.exports